<template>
 <div class="model" v-if="isModelData">
      <div class="model-data">
        <div class="model-head">
          <p class="close" @click.stop="handleModelClose">取消</p>
          <p class="head-title">选择课表时间</p>
          <p class="ok" @click="confirmDataOk">确定</p>
        </div>
        <div class="model-main">
          <ul class="main-menu">
            <li class="menu-li" v-for="(item,index) in list" :key="index" @click="handleChange(item,index)">
              <img src="../../../assets/images/grade/radio.png" alt="" class="icon-radio" v-if="item && item.checked"/>
              <img src="../../../assets/images/grade/no-radio.png" alt="" class="icon-radio" v-else/>
              <p class="title">Day{{ index+1 }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      isModelData: false,
      checked: false,
      transferUserId: '',
      // list: [{checked: false}],
    }
  },
  methods: {

    handleChange(item, index) {
      this.list.forEach(acc => {
        if (acc.value === item.value) {
          this.transferUserId = item.value
          acc.checked = true
        } else {
          acc.checked = false
        }
      })
      this.$forceUpdate()
    },
    init() {
      this.isModelData = !this.isModelData
    },
    handleModelClose() {
      this.isModelData = !this.isModelData
      this.transferUserId = ''
    },
    confirmDataOk() {
      this.$emit('changeDay', this.transferUserId)
      this.isModelData = !this.isModelData
    }
  }
}
</script>

<style scoped lang="less">
.model{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0,0,0,0.6);
  .model-data{
    width: 100%;
    box-sizing: border-box;
    height: 50vh;
    background: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    padding:10px 16px 20px;
    z-index: 9999;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    &::before{
      content:"";
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      background: url('../../../assets/images/grade/mock-box-bg.png') no-repeat center center / 100% 100%;
      width: 100%;
      height: 63px;
    }
    .model-head{
      width: 100%;
      display: flex;
      font-size: 14px;
      font-weight: 400;
      position: relative;
      z-index: 3;
      .close{
        color: #000000;
      }
      .head-title{
        flex: 1;
        text-align: center;
        font-weight: 600;
        color: #000000;
      }
      .ok{
        color: #EB1700;
      }
    }
    .model-main{
      margin-top: 16px;
      .main-menu{
        list-style: none;
        position: relative;
        .menu-li{
          display: flex;
          align-items: center;
          height: 46px;
          border-bottom: 1px solid rgba(0,0,0,0.08);
          .icon-radio{
            width: 13px;
            height: 13px;
            margin-right: 14px;
          }
          .title{
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 600;
            font-size: 14px;
            color: #000000;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/weekPopup.vue